/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PatientDemographicsIntegrationViewModel } from './patientDemographicsIntegrationViewModel';
import { PatientInsuranceIntegrationViewModel } from './patientInsuranceIntegrationViewModel';
import { PatientVisitIntegrationViewModel } from './patientVisitIntegrationViewModel';
import { GuarantorDemographicsIntegrationViewModel } from './guarantorDemographicsIntegrationViewModel';

/**
 * Add Patient view model containing Patient and Guarantor demographics,  Insurances, and Visits
 */
export interface AddPatientIntegrationViewModel {
  /**
   * Dataset Id
   */
  datasetId?: string;
  /**
   * Sending Facility Code, Must match to a Sending Facility in System Maintenance, max length 200
   */
  sendingFacilityCode?: string | null;
  /**
   * External account number. Unique identifier to link patient account to imported data. Max length 50
   */
  externalAccountNumber?: string | null;
  patient?: PatientDemographicsIntegrationViewModel;
  guarantor?: GuarantorDemographicsIntegrationViewModel;
  insurances?: Array<PatientInsuranceIntegrationViewModel> | null;
  visits?: Array<PatientVisitIntegrationViewModel> | null;
}
